export class ClDragDirective implements angular.IDirective {
    public static $name: string = 'clDragElement';
    public restrict: string = 'A';

    public scope: any = {
        clDrag: '&',
        clDragElement: '@',
        clEnd: '&',
        clLeave: '&',
        clOver: '&'
    };

    public link = (scope: angular.IScope | any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        const ele = element[0];

        if (scope.clDragElement === 'false') {
            ele.removeAttribute('draggable');
            if (!ele.attributes.getNamedItem('title')) {
                ele.setAttribute('title', 'You cannot drag this!');
            }
            return;
        }

        ele.setAttribute('draggable', 'true');

        const dragStart = event => {
            scope.clDrag({ event: event });
        };

        const dragEnd = event => {
            scope.clEnd({ event: event });
        };

        const dragOver = event => {
            scope.clOver({ event: event });
        };

        const dragLeave = event => {
            scope.clLeave({ event: event });
        };

        ele.addEventListener('dragstart', dragStart);
        ele.addEventListener('dragend', dragEnd);
        ele.addEventListener('dragover', dragOver);
        ele.addEventListener('dragleave', dragLeave);

        scope.$on('$destroy', () => {
            ele.removeEventListener('dragstart', dragStart);
            ele.removeEventListener('dragend', dragEnd);
            ele.removeEventListener('dragover', dragOver);
            ele.removeEventListener('dragleave', dragLeave);
        });
    }

    public static Factory() {
        const directive = () => {
            return new ClDragDirective();
        };

        return directive;
    }
}
